import { render, staticRenderFns } from "./VejaTodos.vue?vue&type=template&id=c5025200&"
import script from "./VejaTodos.js?vue&type=script&lang=js&"
export * from "./VejaTodos.js?vue&type=script&lang=js&"
import style0 from "./VejaTodos.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
